import apiClient from './apiClient';

export const getAllRoles = async () => {
  const response = await apiClient.post('/role/GetAllRoles');
 
  return response.data.Data.Items || [];
};

export const getRoleById = async (id) => {
  const response = await apiClient.post('/role/GetRoleById', null, { params: { id } });
  return response.data.Data;
};

export const addRole = async (role) => {
  const response = await apiClient.post('/role/AddRole', role);
  return response.data;
};

export const updateRole = async (role) => {
  const response = await apiClient.post('/role/UpdateRole', role);
  return response.data;
};

export const deleteRole = async (id) => {
  const response = await apiClient.post('/role/DeleteRole', null, { params: { id } });
  return response.data;
};
